import {Injectable} from '@angular/core';
import {Promo} from '../models/promo.model';
import {NearByPromo} from '../models/nearbypromo.model';
import {LoggingService} from './LoggingService.service';
import {DataServices} from './data.services';

@Injectable()
export class NearByPromosService{


  branches: NearByPromo[] = [];


  constructor(private dataServices: DataServices){}


  getNearByPromoBranches(idCard: number, userLat: number, userLon: number){
    return this.dataServices.getNearByPromosByCard(idCard, userLat, userLon);
  }

  setNearByPromoBranches(branches: NearByPromo[]){
    this.branches = branches;
  }


}
